import back from "../../assats/img1112.jpg";
import FormContactUs from "../../components/formCntactUs/FormContactUs";
import "./ContactUs.css";
import { useEffect } from "react";
export default function ContactUs() {
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth" // Smooth scrolling animation
    });
  }


  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <>
      <div
        className="interface-section-contactus-page container"
        style={{ backgroundImage: `url(${back})` }}
      >
        <h1 className="title-contactus-page">تواصل معنا</h1>
      </div>
      <div className="main-contactus-page container">
        <FormContactUs />
        <div className="contant-contactus">
          <div className="top-content-contactus-page">
            <h1 className="head-text-section-2 head-text-section-2-3">
              بيانات التواصل
            </h1>
            <div className="location-container">
              <i className="bi bi-geo-alt-fill icon-location"></i>
              <p className="location-address">
                المملكة العربية السعودية-جدة طريق المدينة المنورة 
              </p>
            </div>
            {/* <div className="location-container">
              <i className="bi bi-telephone-fill icon-location"></i>
              <p className="location-address">00966126222282</p>
            </div> */}
            {/* <div className="location-container">
              <i className="bi bi-envelope-fill icon-location"></i>
              <p className="location-address"></p>
            </div> */}
            <div className="location-container">
            <a href="https://x.com/abaadre_sa">
            <i className="bi bi-twitter-x icon-locationn"></i>
              </a>
              <a href="https://www.instagram.com/abaadre_sa/">
              <i className="bi bi-instagram icon-locationn"></i>
              </a>
              <a href="https://youtube.com/@abaad_net?si=DfCklHNHNc9tBtHy">
              <i className="bi bi-youtube icon-locationn"></i>
              </a>
              <a href="https://www.tiktok.com/@abaadre_sa">
              <i className="bi bi-tiktok icon-locationn"></i>
              </a>
              <a href="https://www.linkedin.com/company/abaadnetsa/">
              <i className="bi bi-linkedin icon-locationn"></i>
              </a>
            </div>
          </div>
          <div className="bottom-content-contactus-page">
            <iframe
          
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29108.489845731314!2d45.035974574316405!3d24.222142000000005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x20eba89c8d9f237f%3A0x5f8d92649a5bc5d9!2z2LTYsdmD2Kkg2KPYqNi52KfYryDYp9mE2LnZgtin2LHZitip!5e0!3m2!1sen!2ssa!4v1746095568353!5m2!1sen!2ssa"
              width="100%"
              height="100%"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
}
